import(/* webpackMode: "eager", webpackExports: ["CheckinCarouselClient"] */ "/vercel/path0/apps/web/src/components/checkins/CheckinCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/apps/web/src/components/footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PhoneHero"] */ "/vercel/path0/apps/web/src/components/grabber/PhoneHero/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Scroll"] */ "/vercel/path0/apps/web/src/components/grabber/Scroll.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrainerAttention"] */ "/vercel/path0/apps/web/src/components/grabber/TrainerAttention.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationBar"] */ "/vercel/path0/apps/web/src/components/navigation/NavigationBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.3.8_@babel+core@7.23.0_react-dom@19.1.3_react@19.1.3_sass@1.69.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.8_@babel+core@7.23.0_react-dom@19.1.3_react@19.1.3_sass@1.69.0/node_modules/next/dist/client/image-component.js");
